let fadeIn = (element, duration) => {
    element.style.opacity = 0;
    element.style.transition = "opacity " + duration + "ms linear";
    element.style.display = "block";

    setTimeout(() => {
        element.style.opacity = 1;
    }, duration);
}

let fadeOut = (element, duration) => {
    element.style.opacity = 1;
    element.style.transition = "opacity " + duration + "ms linear";

    setTimeout(() => {
        element.style.opacity = 0;
        element.style.display = "none";
    }, duration);
}

document.addEventListener('DOMContentLoaded', () => {
    const productFeatures = document.querySelectorAll(".ce_product-feature:not(.inactive)");
    for (const productFeature of productFeatures) {
        productFeature.addEventListener('click', (e) => {
            if (e.target.closest('.pf-popup')) {
                e.stopPropagation();
                return;
            }
            e.preventDefault();
            const popup = productFeature.querySelector(".pf-popup");
            if (popup !== null) {
                let overlay = document.querySelector('.overlay');
                if (overlay !== null) {
                    fadeIn(overlay, 300);
                }
                fadeIn(popup, 300);
            }
        });
    }

    const productFeatureCloseButtons = document.querySelectorAll(".ce_product-feature .pf-popup .close");
    for (const closeButton of productFeatureCloseButtons) {
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            let overlay = document.querySelector('.overlay');
            if (overlay !== null) {
                fadeOut(overlay, 500);
            }

            const popup = closeButton.closest('.pf-popup');
            if (popup !== null) {
                fadeOut(popup, 500);
            }
        });
    }
});

